
import { NavbarText } from "reactstrap";

import cn from "classnames"

import { useScenario } from "../../contexts/ScenarioContext";

import TimerIcon from "../icons/TimerIcon"

import { formatAsMinSecs } from "../../utils"

const Timer = () => {
	const { started, paused, timers } = useScenario()

	const scenTimer = timers.find(timer => timer.id === "scenario")

	const getColor = () => {
		if (scenTimer.expired) {
			return "text-danger"
		}
		if (started && !paused) {
			return "text-success"
		}
		if (paused || !started) {
			return ""
		}

	}

	return (
		<>
			{/* <TimerIcon running={started && !paused} /> */}
			<NavbarText className={cn("time-remaining", getColor())}>
				{formatAsMinSecs(scenTimer.timeRemaining)}
			</NavbarText>
		</>
	)
}

export default Timer